define('lib/animations/filters.animations',['jquery', 'lib/shim/gsap'], function ($, gsap) {
  var __$html = $('html');

  return {
    open: function () {
      gsap.TweenMax.to('#filters-panel', 0, { left: 0, visibility: 'initial' });
      gsap.TweenMax.from('#filters-panel', 0.25, {
        opacity: 0,
        onComplete: function () {
          __$html.addClass('filters-open');
        }
      });
      gsap.TweenMax.staggerFrom(
        '#filters-panel .sticky li:visible, #filters-panel .sticky > div',
        0.25, // duration of entire animation
        {
          marginLeft: '25%',
          opacity: 0,
          clearProps: 'all',
          ease: Expo.easeOut, // https://greensock.com/ease-visualizer
        },
        0.03 // stagger time,
      );
    },

    close: function () {
      gsap.TweenMax.to('#filters-panel', 0.25, {
        opacity: 0,
        clearProps: 'all',
        onComplete: function () {
          __$html.removeClass('filters-open');
        }
      });
      gsap.TweenMax.to('#filters-panel', 0, { left: '-100%', visibility: 'hidden', delay: 0.25 });
    }
  }
});

